<template>
  <div
    class="uesr-info"
    :class="{'is-open':isPopover}"
    @click.stop="clickPopover"
  >
    <img
      class="avatar"
      :src="user.wechatAvatarUrl? user.wechatAvatarUrl :avatarImg"
    >
    <div class="info">
      <span class="account">{{ user.loginName }}</span>
    </div>
    <i class="el-icon-caret-bottom" />
    <div
      v-if="isPopover"
      class="popover"
    >
      <div
        class="item"
        @click="changePsw"
      >
        修改密码
      </div>
      <div
        class="item"
        @click="quit"
      >
        退出登录
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import avatarImg from '@/assets/images/header/avatar.png';
import axClient from '@/services';

export default {
  name: 'FixedHeader',
  components: { },
  data() {
    return {
      isPopover: false,
      avatarImg,
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  mounted() {
    document.onclick = () => {
      this.isPopover = false;
    };
  },
  methods: {
    clickPopover() {
      this.isPopover = !this.isPopover;
    },
    // 退出登录
    async quit() {
      const data = await axClient.login.logout();
      if (data) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.reload();
      }
    },
    // 修改密码
    changePsw() {
      this.$emit('changePsw');
    },
  },
};
</script>
<style lang="scss" scoped>
.uesr-info {
  display: flex;
  margin-right: 95px;
  align-items: center;
  position: relative;
  cursor: pointer;
  i {
    color: $--base-color-black;
    transition: transform 0.5s;
  }
  &.is-open {
    i {
      transform: rotate(180deg);
    }
  }
  img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #eee;
    margin-right: 8px;
  }
  .info {
    display: inline-flex;
    justify-content: center;
    flex-direction: column;
    color: $--base-color-black;
    font-size: 12px;
    margin-right: 8px;
    span {
      line-height: 18px;
    }
    .name {
      font-weight: 500;
    }
    .account {
      font-weight: normal;
    }
  }
  .popover {
    position: absolute;
    top: 50px;
    width: 100%;
    min-width: 150px;
    padding: 0 20px;
    text-align: center;
    background: $--base-color-white;
    box-shadow: 0 1px 20px rgba($--base-color-black, 0.1);
    border-radius: 3px;
    .item {
      padding: 15px 0;
      font-size: 12px;
      &:hover {
        color: $--base-color-main;
      }
      &:first-child {
        border-bottom: 1px solid #f5f5f5;
      }
    }
  }
}
</style>
